module.exports = __webpack_public_path__ + "static/media/CPS-1920x1080-5.9fe04159.png";